import BasicResource from '@/api/resource';

class BlacklistResource extends BasicResource {

    constructor () {
        super('blacklist');
    }
}

export default new BlacklistResource;
